import { IconButton } from "@remo-co/ui-core/src/components/IconButton";
import { Tooltip } from "@remo-co/ui-core/src/components/Tooltip";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { ZoomOutMap as MaximizeIcon } from "@remo-co/ui-core/src/icons/ZoomOutMap";
import { useSelector } from "react-redux";
import {
  selectCurrentEventName,
  selectEventLogoUrl,
  selectIsEventManager,
} from "modules/event/selectors";
import { useI18n } from "i18n";
import { useStyles } from "./styles";

interface Props {
  onEventLogoClick: () => void;
  hasEventMap: boolean;
}

export const DefaultView = ({ onEventLogoClick, hasEventMap }: Props) => {
  const title = useSelector(selectCurrentEventName);
  const eventLogoURL = useSelector(selectEventLogoUrl);
  const isEventManager = useSelector(selectIsEventManager);
  const classes = useStyles({ hasEventMap });
  const { t } = useI18n(["theater"]);

  const showLogo = eventLogoURL && isEventManager;

  return (
    <>
      {showLogo && (
        <Tooltip title={t("theater:click.enlarge.picture") as string}>
          <div className={classes.imageThumbnail}>
            <img src={eventLogoURL} alt="Event Logo" />
            <IconButton
              onClick={onEventLogoClick}
              className={classes.maximizeBtn}
              data-testid="event-logo-button"
              size="large"
            >
              <MaximizeIcon />
            </IconButton>
          </div>
        </Tooltip>
      )}
      <div className={classes.mapBannerText}>
        <Typography variant="h4" color="textPrimary" className={classes.title}>
          {title}
        </Typography>
      </div>
    </>
  );
};
